import {
  GenerateImageStore,
  IMAGE_SIDEBAR_MENU,
} from '@/pages/generate-image/store';
import {
  GenerateVideoStore,
  VIDEO_SIDEBAR_MENU,
} from '@/pages/generate-video/store';
import MarketingStore from '@/store/marketing';
import stateStore from '@/pages/square-video/state-store';
import userStore from '@/store/user';
import { SVGPureIcon } from '@/ui';
import appLogger from '@public/log/monitor';
import { urlParams } from '@q/solib-utils';
import { Menu, MenuProps } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import './index.scss';
import { aigcFormStore, type FormType } from '@/components/aigc-form/store';
import { aiToolsMap } from '@/pages/square-image/store';
import client from '@/store/client';
import { ModifyImageStore } from '@/pages/modify-image/store';

// 定义菜单项类型
type MenuItem = {
  key: string;
  icon?: string;
  activeIcon?: React.ReactNode;
  label: React.ReactNode;
  children?: MenuItem[];
  path?: string;
  extraPaths?: string[]; // 添加额外路径配置
};

// // 获取时间分组
// const getTimeGroup = (createTime: string) => {
//   const createDate = new Date(createTime);
//   const today = new Date();
//   today.setHours(23, 59, 59, 999);

//   const diffTime = today.getTime() - createDate.getTime();
//   const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

//   if (diffDays === 0) {
//     return '今天';
//   } else if (diffDays <= 1) {
//     return '昨天';
//   } else if (diffDays <= 2) {
//     return '前天';
//   } else if (diffDays <= 7) {
//     return '最近7天';
//   } else {
//     return `更早`;
//   }
// };

// 顶部独立菜单项 - 改为函数以动态获取标签
const getTopMenuItems = (fromHome: string) => {
  // 营销云
  if (MarketingStore.isMarketingCloud) {
    return [
      {
        key: 'my-works',
        icon: <SVGPureIcon name="my-work" size="18" />,
        activeIcon: <SVGPureIcon name="my-work" className='text-[#5A5EFD]' size="18" />,
        label: '我的作品',
      },
    ];
  }
  return [
    {
      key: 'home',
      icon: <SVGPureIcon name="work-home" size="18" />,
      activeIcon: <SVGPureIcon name="work-home" className='text-[#5A5EFD]' size="18" />,
      label: fromHome === 'video' ? '视频广场' : '图片广场',
    },
    {
      key: 'my-works',
      icon: <SVGPureIcon name="my-work" size="18" />,
      activeIcon: <SVGPureIcon name="my-work" className='text-[#5A5EFD]' size="18" />,
      label: '我的作品',
    },
  ];
}

// const onActiveTask = item => {
//   if (stateStore.fromHome === 'video') {
//     let type = item.biz_type;
//     if (item.biz_type === 'image_video_frame') {
//       type = 'image_video';
//     }
//     stateStore.setLocation(`/generate/video?form_type=${type}`);
//   } else {
//     stateStore.setLocation(`/generate/image?form_type=${item.biz_type}`);
//   }
// };

const IMAGE_NEW_ITEMS = [
  {
    key: 'sub2',
    label: 'AI修图',
    icon: <SVGPureIcon name="tool_box" size="18" />,
    children: Object.keys(aiToolsMap).map(key => aiToolsMap[key])
  },
];

// 递归处理菜单项，添加Link组件
const processMenuItems = (items: MenuItem[]): MenuProps['items'] => {
  if (!items) {
    return;
  }
  return items.map(item => {
    const { key, icon, label, children, path } = item;
    const iconDom = icon ? <SVGPureIcon name={icon} size="18" /> : null;
    if (children) {
      return {
        key,
        icon: iconDom,
        label,
        children: processMenuItems(children),
      };
    }
    return {
      key,
      icon: iconDom,
      label: path ? <span>{label}</span> : label,
    };
  });
};

const SidebarNav = observer(() => {
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [activeTopItem, setActiveTopItem] = useState<string>('');
  const [routerParams] = useSearchParams();
  const pageType = routerParams.get('page_type')
  const [menuItems, setMenuItems] = useState(
    stateStore.fromHome === 'video' ? VIDEO_SIDEBAR_MENU : IMAGE_SIDEBAR_MENU
  );
  // 使用 useMemo 动态计算顶部菜单项
  const topMenuItems = useMemo(() => getTopMenuItems(stateStore.fromHome), [stateStore.fromHome]);

  // 使用useMemo创建GenerateStore，当stateStore.fromHome变化时会重新计算
  const GenerateStore = useMemo(
    () =>
      stateStore.fromHome === 'video' ? GenerateVideoStore : GenerateImageStore,
    [stateStore.fromHome]
  );

  // useEffect(() => {
  //   // 初始化任务列表，这会同时启动对进行中任务的轮询
  //   GenerateStore.initTaskList();
  //   // 组件卸载时停止轮询
  //   return () => {
  //     GenerateStore.stopPollingTasks();
  //   };
  // }, [GenerateStore]); // 添加GenerateStore作为依赖项

  useEffect(() => {
    setMenuItems(
      stateStore.fromHome === 'video' ? VIDEO_SIDEBAR_MENU : IMAGE_SIDEBAR_MENU
    );
  }, [stateStore.fromHome]);

  const getLogKey = () => {
    if (pageType === 'effect') {
      return 'aibot_video_creation';
    }
    if (location.pathname.startsWith('/generate')) {
      return `aibot_${stateStore.fromHome === 'video' ? 'video' : 'photo'}_creation`;
    }
    if (location.pathname.startsWith('/works')) {
      return `aibot_${stateStore.fromHome === 'video' ? 'video' : 'photo'}_home`;
    }
    return `aibot_${stateStore.fromHome === 'video' ? 'video' : 'photo'}_home`;
  };

  const getLogArrt = () => {
    if (pageType === 'effect') {
      return 'effect_video_list';
    }
    if (location.pathname.startsWith('/generate')) {
      return `${stateStore.fromHome === 'video' ? 'video' : 'photo'}_creation`;
    }
    if (location.pathname.startsWith('/works')) {
      return `${stateStore.fromHome === 'video' ? 'video' : 'photo'}_mytask`;
    }
    return `aibot_${stateStore.fromHome === 'video' ? 'video' : 'photo'}_home`;
  };
  const getLogExt = () => {
    if (pageType === 'effect') {
      return 'effect_video_list';
    }
    if (location.pathname.startsWith('/square')) {
      return 'sidebar';
    }
    return urlParams.get('form_type').form_type;
  };

  const toHome = () => {
    appLogger.log({
      key: getLogKey(),
      arrt: getLogArrt(),
      action: 'click',
      type: `${stateStore.fromHome === 'video' ? 'video' : 'photo'}_home`,
      user_id: userStore.uid,
      ext: getLogExt(),
    });
    stateStore.toHome();
  };

  // const handleLoadMore = () => {
  //   if (GenerateStore.hasMore) {
  //     GenerateStore.loadMoreTasks();
  //   }
  // };

  // const onDeleteTask = (item) => {
  //   appLogger.log({
  //     key: 'aibot_video_creation',
  //     action: 'click',
  //     type: 'delete',
  //     ext: item.biz_type,
  //     task_id: item?.id_str,
  //     work_id: JSON.parse(item?.data || '{}')?.id,
  //   });
  //   TaskDeleteConfirm.show({
  //     type: 'task',
  //     handleAction: () => {
  //       GenerateStore.deleteTaskItem(item);
  //       TaskDeleteConfirm.close();
  //     },
  //   });
  // };

  const onSelectImageAITools = (e: { key: string }) => {
    const { link, path } = aiToolsMap[e.key];
    if (path) {
      stateStore.setLocation(path);
      ModifyImageStore.setActiveTask(null, e.key);
      ModifyImageStore.setHistoryActiveTask(e.key, null);
    } else {
      client.openPage(link);
    }
  }

  const onSelect = (e: { key: string }) => {
    const { key } = e;
    const items = [];
    // 添加空值检查
    if (!menuItems) return;

    menuItems.forEach(item => {
      if (item.children) {
        items.push(...item.children);
      } else {
        items.push(item);
      }
    });
    const item = items.find(item => {
      return item.key === key;
    });
    appLogger.log({
      key: getLogKey(),
      arrt: getLogArrt(),
      action: 'click',
      type: item.key,
      user_id: userStore.uid,
      ext: getLogExt(),
    });
    const value = aigcFormStore.getFormValue('effect_video', 'template_id');

    if (value && item.path.includes('effect')) {
      stateStore.setLocation('/generate/video?form_type=effect_video');
      return
    }
    stateStore.setLocation(item?.path);
  };

  // 初始化时设置默认展开的菜单
  useEffect(() => {
    // 默认展开图生视频菜单
    if (stateStore.fromHome === 'video') {
      setOpenKeys(['video']);
    } else {
      setOpenKeys(['']);
    }
  }, [stateStore.fromHome]);

  // 根据当前路径设置选中的菜单项
  useEffect(() => {
    if (!menuItems) return;
    const { pathname, search } = location;
    // 检查主菜单项
    const findMatchingKey = (items: MenuItem[]): string | null => {
      for (const item of items) {
        if (item.children) {
          const childKey = findMatchingKey(item.children);
          if (childKey) {
            // 确保父菜单保持展开状态
            if (!openKeys.includes(item.key)) {
              setOpenKeys(prev => [...prev, item.key]);
            }
            setSelectedKeys([childKey]);
            return childKey;
          }
        }

        // 检查主路径
        if (item.path) {
          const [path, param] = item.path.split('?');
          const reg = new RegExp(`${param || ''}(?!_)`);
          if (path === pathname && reg.test(search)) {
            return item.key;
          }
        }

        // 检查额外路径
        if (item.extraPaths && Array.isArray(item.extraPaths)) {
          for (const extraPath of item.extraPaths) {
            const [path, param] = extraPath.split('?');
            const reg = new RegExp(`${param}(?!_)`);
            if (path === pathname && reg.test(search)) {
              return item.key;
            }
          }
        }
      }
      return null;
    };
    const allMenuItems = [...VIDEO_SIDEBAR_MENU, ...IMAGE_SIDEBAR_MENU, ...IMAGE_NEW_ITEMS[0].children];
    const matchedKey = findMatchingKey(allMenuItems);
    setActiveTopItem('');
    if (matchedKey) {
      setSelectedKeys([matchedKey]);
    } else {
      // 清除来源  防止在首页和我的作品时选中任务项
      GenerateStore?.setSource('');
      setSelectedKeys([]);
      // GenerateStore.setActiveTask(null, null);
      if (pathname === `/square/${stateStore.fromHome}`) {
        setActiveTopItem('home');
      } else if (pathname.startsWith('/works')) {
        const params = urlParams.parse(search);
        if (!params.qid || params.qid === `${userStore.uid}`) {
          setActiveTopItem('my-works');
        }
      }
    }
  }, [location]);

  // 处理子菜单展开/收起
  const onOpenChange: MenuProps['onOpenChange'] = keys => {
    appLogger.log({
      key: getLogKey(),
      arrt: getLogArrt(),
      action: 'click',
      type: 'image_to_video',
      user_id: userStore.uid,
      ext: getLogExt(),
    });
    setOpenKeys(keys);
  };

  // useBroadcast('work-task-changed', () => {
  //   GenerateStore.initTaskList();
  // });

  // 对任务列表进行分组
  // const groupedTasks = useMemo(() => {
  //   if (!GenerateStore.taskList || GenerateStore.taskList.length === 0) {
  //     return [];
  //   }

  //   // 创建分组对象
  //   const groups = {};

  //   // 对任务进行分组
  //   GenerateStore.taskList.forEach((task, index) => {
  //     const createTime = task.create_time || task.finish_time;
  //     const groupName = getTimeGroup(createTime);

  //     if (!groups[groupName]) {
  //       groups[groupName] = [];
  //     }

  //     groups[groupName].push({ ...task, index });
  //   });

  //   // 转换为数组格式，方便渲染
  //   const result = [];
  //   const groupOrder = ['今天', '昨天', '前天', '最近7天', '更早'];

  //   groupOrder.forEach(groupName => {
  //     if (groups[groupName] && groups[groupName].length > 0) {
  //       result.push({
  //         type: 'group',
  //         title: groupName,
  //       });

  //       result.push(...groups[groupName]);
  //     }
  //   });
  //   return result;
  // }, [GenerateStore.taskList]);

  return (
    <div className="relative flex flex-col flex-shrink-0 w-[180px] h-full bg-white select-none">
      <div className='sidebar-nav flex flex-col w-full h-full px-[14px] py-[20px] overflow-y-auto nw-scrollbar'>
        {/* 顶部独立菜单项 */}
        <div className="flex flex-col gap-4px">
          {topMenuItems.map(item => (
            <div
              key={item.key}
              className={`flex items-center rounded-[12px] px-14px h-[48px] text-[14px] font-bold cursor-pointer transition-colors ${activeTopItem === item.key
                ? 'top-menu-item-active'
                : 'top-menu-item'
                }`}
              onClick={() => {
                if (item.key === 'home') {
                  toHome();
                } else {
                  appLogger.log(
                    {
                      key: getLogKey(),
                      action: 'click',
                      arrt: getLogArrt(),
                      type: `${stateStore.fromHome === 'video' ? 'video' : 'photo'}_mytask`,
                      user_id: userStore.uid,
                      ext: getLogExt(),
                    },
                    'click'
                  );
                  stateStore.setLocation(`/works/${stateStore.fromHome}?qid=${userStore.uid}`);
                }
              }}
            >
              <span className="mr-10px">
                {activeTopItem === item.key && item.activeIcon
                  ? item.activeIcon
                  : item.icon}
              </span>
              <span className='label-box'>{item.label}</span>
            </div>
          ))}
        </div>

        {/* 分割线 */}
        <div className="h-[1px] bg-[#f0f0f0] my-14px mx-12px"></div>

        {/* 主菜单 */}
        <Menu
          mode="inline"
          openKeys={openKeys}
          defaultOpenKeys={['video']}
          selectedKeys={selectedKeys}
          onOpenChange={onOpenChange}
          onSelect={onSelect}
          items={processMenuItems(menuItems)}
          style={{ borderRight: 0 }}
        />

        {/* 分割线 */}
        {
          stateStore.fromHome === 'image' &&
          <>
            <div className="h-[1px] bg-[#f0f0f0] my-14px mx-12px"></div>
            <Menu
              mode="inline"
              defaultOpenKeys={['sub2']}
              items={IMAGE_NEW_ITEMS}
              selectedKeys={selectedKeys}
              onClick={onSelectImageAITools}
            />
          </>
        }

        {/* 我的作品 */}
        {/* <div className="mt-14px flex flex-col flex-grow overflow-hidden">
          <div className="px-12px mb-10px font-bold">我的作品</div>
          <div
            id="history_wrap"
            className="overflow-y-auto flex-grow scrollbar-hide"
          >
            <InfiniteScroll
              dataLength={GenerateStore.taskList.length}
              loader={null}
              next={handleLoadMore}
              hasMore={GenerateStore.hasMore}
              scrollableTarget="history_wrap"
            >
              {groupedTasks.map((item, idx) => {
                // 日期分组标题
                if (item.type === 'group') {
                  return (
                    <div
                      key={`group-${item.title}`}
                      className="text-12px text-[#00000080] px-12px mt-16px mb-8px"
                    >
                      {item.title}
                    </div>
                  );
                }
                // 任务项
                return (
                  <Item
                    onDeleteTask={onDeleteTask}
                    id={GenerateStore.activeTaskId}
                    key={item.id_str}
                    item={item}
                    onClick={e => {
                      e.stopPropagation();
                      onActiveTask(item);
                      GenerateStore?.setSource('task');
                      GenerateStore.setActiveTask(item, item.biz_type, true);
                    }}
                  />
                );
              })}
            </InfiniteScroll>
          </div>
        </div> */}
      </div>
    </div>
  );
});

export default SidebarNav;
